export default {"src":"/_next/static/media/rp-logo-mark.3f6680b7.svg","height":18,"width":172};